import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../../Content";
import BaseUrl from "../../../../utils/BaseUrl";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select from 'react-select';
import SwalTopEnd from "../../../../utils/swal_top_end";
import { UserContext } from "../../../../utils/User_check";
import can from "../../../../utils/Can";


const url = BaseUrl();
function AddUserPage(){
  const [roleList,setRoleList] = useState([]);
  const [errors,setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState();
  const [distributeurs,setDistributeurs] = useState([]);
  const [selectRole,setSelectRole] = useState(null);
  const [selectDistributeur,setSelectDistributeur] = useState(null);

  const [itemsData,setItemsData] = useState({
    'name':'',
    'last_name':'',
    'email':'',
    'phone':'',
    'role_id':'',
    'send_mail_status':'0'
});

const {user,role, permissions} = useContext(UserContext);
const navigate = useNavigate();
useEffect(()=>{
  if(user && permissions && !can(permissions,'LISTE DES UTILISATEURS')){
      navigate('/page-no-found');
  }
},[user]);

useEffect(()=>{
  fetchRoleList();
  fetchDistributeurList();
},[]);

const fetchRoleList = async ()=>{

  try {
      axios.get(url.base+'/role-list',{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`
              
          },
      }).then((resp)=>{

          if(resp.status == 200){
              setRoleList(resp.data.data);
          }
      })
  } catch (error) {
      // setLoading(false);
  }
}

const fetchDistributeurList = async ()=>{
  setLoading(true);
  try {
    axios.get(url.base+'/distributeur-list',{
      headers:{
          'Content-Type':'application/json',
          "Authorization": `Bearer ${localStorage.getItem('_token_')}`
          
      },
  }).then((resp)=>{

          if(resp.status == 200){
            setDistributeurs(resp.data.data);
          }
          setLoading(false);
      })
  } catch (error) {
      setLoading(false);
  }
}


const handleChange=(e)=>{
  setItemsData({
      ...itemsData,
      [e.target.name]:e.target.value
  });
}

const handleChangeDistributeur=(selectoption)=>{
  setSelectDistributeur(selectoption.value);
}

const handleChangeRole=(selectoption)=>{
  setSelectRole(selectoption.value);
}


const optiondistributeur = distributeurs?.map((opt)=>({
  value: opt.id,
  label:`${opt.raison_social}`
}));

const optionsroles = roleList.map((opt)=>({
  value: opt.name,
  label:`${opt.name}`
}));

const submitForm= async(e)=>{
  e.preventDefault();
  const _formData = new FormData();

  _formData.append("name",itemsData.name);
  _formData.append("last_name",itemsData.last_name);
  _formData.append("phone",itemsData.phone);
  _formData.append("email",itemsData.email);
  // _formData.append("distributeur_id",selectDistributeur !== null ? selectDistributeur : "");
  _formData.append("role_id",itemsData.role_id);
  _formData.append("send_mail_status",itemsData.send_mail_status);

  console.log(_formData);
    setLoading(true);
    try {
        axios.post(url.base+'/users-store',_formData,
        {
            headers:{
                'Content-Type':'multipart/form-data',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`                   
            },
            credentials:'include'
        }
        ).then((resp)=>{          
          setLoading(false);

          SwalTopEnd({icon:'success',title:'Opération effectuée avec succès'});
          navigate('/parametres/users')
          setErrors({});             
        }).catch((error)=>{
          setLoading(false);
          setError(error?.response?.data.message);
          setErrors(error?.response?.data.error);

        })
    } catch (error) {
    setLoading(false);
    console.log(error.response);
    } 
}

    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Formulaire de création d'un utilisateur</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              <div class="header-left">
                <Link class="btn btn-warning mb-2 mb-md-0 mr-2" to="/parametres/users"><i class="mdi mdi-backburger"></i> Retour à la liste</Link>
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Nouvel utilisateur</h4>
                    <p class="card-description">Tous les champs sont obligatoires</p>
                    <form class="forms-sample" onSubmit={submitForm}>
                      <div class="form-group">
                        <label for="exampleInputName1">Nom</label>
                        <input type="text" class="form-control" onChange={handleChange} name="name" />
                        {errors && errors.name && (
                            <span className="text-danger">{errors.name[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail3">Prénoms</label>
                        <input type="text" class="form-control" onChange={handleChange} name="last_name" />
                        {errors && errors.last_name && (
                            <span className="text-danger">{errors.last_name[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword4">Numéro de téléphone</label>
                        <input type="text" class="form-control" onChange={handleChange} name="phone" />
                        {errors && errors.phone && (
                            <span className="text-danger">{errors.phone[0]}</span>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="exampleInputCity1">Adresse email</label>
                        <input type="email" class="form-control" onChange={handleChange} name="email" />
                        {errors && errors.email && (
                            <span className="text-danger">{errors.email[0]}</span>
                        )}
                      </div>

                    <div className="row">
                        <div class="form-group col-md-6">
                              <label className="form-label">RÔLE</label>
                              <select  className="form-control" id="roleId" onChange={handleChange} name="role_id">
                                  <option value="" selected>----</option>
                                  {roleList && roleList.map((item,index)=>
                                      <option value={item.id}>{item.name}</option>
                                  )}
                              </select>
                              {errors && errors.role_id && (
                                  <span className="text-danger">{errors.role_id[0]}</span>
                              )}
                          </div> 
                          <div class="form-group col-md-6">
                              <label className="form-label">Rapport Analyse</label>
                              <select  className="form-control" onChange={handleChange} name="send_mail_status" value={itemsData.send_mail_status}>
                                  <option value="0">NON</option>
                                  <option value="1">OUI</option>
                              </select>
                          </div> 
                    </div>
                     
                      {/* <div class="form-group">
                        <label for="exampleSelectGender">Selectionnez un distributeur</label>
                        <Select options={optiondistributeur} onChange={handleChangeDistributeur}/>
                        {errors && errors.distributeur_id && (
                            <span className="text-danger">{errors.distributeur_id[0]}</span>
                        )}
                      </div> */}
                      {/* <div class="form-group">
                        <label for="exampleSelectGender">Selectionnez un rôle</label>
                        <Select options={optionsroles} onChange={handleChangeRole}/>
                          {errors && errors.roles && (
                              <span className="text-danger">{errors.roles[0]}</span>
                          )}
                      </div> */}

                      {!loading && <button type="submit" class="btn btn-primary mr-2"> Enregistrer les informations </button>}
                      {loading &&
                      <button class="btn btn-primary" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          Enregistrement en cours...
                      </button>
                      }
                    </form>
                  </div>
                </div>
            </div>
            </ContentPage>
        </>
    )
}

export default AddUserPage;